import type { AppIconProps } from '../Icons.types';

export const AppLogoutIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;

  return (
    <svg
      {...rest}
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16667 3.66671V2.50004C7.16667 2.19062 7.04375 1.89388 6.82496 1.67508C6.60617 1.45629 6.30942 1.33337 6 1.33337H1.91667C1.60725 1.33337 1.3105 1.45629 1.09171 1.67508C0.872916 1.89388 0.75 2.19062 0.75 2.50004V9.50004C0.75 9.80946 0.872916 10.1062 1.09171 10.325C1.3105 10.5438 1.60725 10.6667 1.91667 10.6667H6C6.30942 10.6667 6.60617 10.5438 6.82496 10.325C7.04375 10.1062 7.16667 9.80946 7.16667 9.50004V8.33337M3.08333 6.00004H11.25M11.25 6.00004L9.5 4.25004M11.25 6.00004L9.5 7.75004"
        stroke="#737781"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
